import { render, staticRenderFns } from "./DataValida.vue?vue&type=template&id=11c9b65c&scoped=true&"
import script from "./DataValida.vue?vue&type=script&lang=js&"
export * from "./DataValida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c9b65c",
  null
  
)

export default component.exports